import { Title } from "@/components/common/typography/Title";
import { pricingData } from "@/data/pricing";

export const BasePricing = () => {
  return (
    <section className="flex flex-col gap-12 bg-[#1C1C1C] px-4 py-20 ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <div className="flex flex-col items-center gap-4">
        <Title text="PRIX DE BASE" position="center" color="secondary" />
      </div>

      <div className="flex flex-col gap-8">
        {pricingData.map((pricing) => (
          <div
            key={pricing.id}
            className="flex flex-col gap-2 border-b border-gray-700 pb-8 last:border-b-0"
          >
            <div className="flex flex-col justify-between gap-4 text-white lg:flex-row lg:items-center">
              <h3 className="text-xl font-bold">{pricing.title}</h3>

              <div className="flex flex-col gap-2 lg:flex-row lg:items-center lg:gap-20">
                <p className="text-gray-300">
                  {pricing.categories.map((cat) => cat.category).join(" / ")}
                </p>

                <p className="font-medium">
                  {pricing.categories.map((cat) => `€${cat.price}`).join(" / ")}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col items-center gap-2">
        <p className="text-sm italic text-white/60">
          Les prix affichés sont pour une inscription annuelle.
        </p>
      </div>
    </section>
  );
};
